import { DropdownField, Form, SubmitButton, TextField, validator as V } from './FormComponents';
import { lateinit, toTitleCase } from 'shared/util';
import { FormGroup } from './FormGroup';
import {
	gameIds,
	GameLicenseSchema,
	GameLicenseUpdateSchema,
	type GameLicense,
	type GameLicenseUpdate as GameLicenseU,
} from 'shared/modelTypes/index';
import { CheckCheck } from 'lucide-static';
import { showToast, Toast } from './Toast';
import { navigate } from 'engine/router';
import { rpc } from 'src/backend';

type GameLicenseEditProps = {
	license: GameLicense;
	users: Record<string, string>;
};

export class GameLicenseEdit extends Base.Component<GameLicenseEditProps> {
	backLink: HTMLElement = lateinit;
	users = this.props.users || {};

	override render(): HTMLElement {
		const { license } = this.props;
		const view: HTMLElement = (
			<div class="flex flex-col gap-3">
				<h2 class="text-gray-700 dark:text-gray-300">Edit Game License</h2>
				<div class="w-fit rounded-lg bg-white p-6 shadow-md dark:bg-gray-800">
					<Form schema={GameLicenseUpdateSchema} onSubmit={this.update.bind(this)} class="flex flex-col gap-6">
						<input type="hidden" name="_id" value={license._id} />
						<div class="flex flex-col gap-6">
							<FormGroup>
								<DropdownField
									name="kind"
									value={license.kind}
									label="Kind"
									validator={V(GameLicenseSchema._def.right.shape.kind)}
									options={gameIds.map((g) => ({ value: g, label: toTitleCase(g) }))}
								/>
								<DropdownField
									name="userId"
									value={license.userId}
									label="Game Master"
									validator={V(GameLicenseSchema._def.right.shape.userId)}
									options={Object.entries(this.users).map(([key, name]) => ({
										value: key,
										label: name,
									}))}
								/>
								<TextField
									name="code"
									value={license.code}
									label="Code"
									validator={V(GameLicenseSchema._def.right.shape.code)}
									placeholder="Code"
								/>
								<TextField
									name="name"
									value={license.name}
									label="Name"
									title="Give the license a name to differentiate between different licenses for the same game"
									optional
									validator={V(GameLicenseSchema._def.right.shape.name)}
									placeholder="Name"
								/>
							</FormGroup>
						</div>
						<SubmitButton>Update License</SubmitButton>
					</Form>
				</div>
			</div>
		);
		return view;
	}

	async update(license: GameLicenseU) {
		this.view.style.pointerEvents = 'none';
		this.view.style.opacity = '0.6';
		const res = await rpc.updateGameLicense.query(license);
		navigate(`/dashboard/licenses`);
		showToast(<Toast icon={CheckCheck} title="License updated!" />, 3000);
	}
}
